import { ca } from '@cian/analytics';
import { IPromoInfoSchema } from '../../types/promo';
import { getProductsData } from '../../selectors/analytics/builder';

export function trackCianMortgageClick(promo: IPromoInfoSchema, newbuildingId: number) {
  const { promoType, uniquePromoId: promoCianMortgage, promoId } = promo;

  ca('eventSite', {
    action: 'click_morgage',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId, promoCianMortgage })],
  });
}
